//@import dependencies
import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import { IconContext } from "react-icons";
import { MdStar } from "react-icons/md";
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../starsCommon.scss'

// @ADD Component types
interface IStarsCommonLayoutProps {
  starts: number
  amount?: number
}

const StarsCommonLayout: React.FC<IStarsCommonLayoutProps> = (props) => {

  const { t } = useTranslation()
  const [listStarts, setListStarts] = useState<Array<{status: 'enabled' | 'disabled'}>>([])
  const amountStarts = props.amount || 5

  useEffect(() => {
    const list: Array<{status: 'enabled' | 'disabled'}> = []
    for (let index = 1; index <= amountStarts; index++) {
      if (index <= props.starts) {
        list.push({status: 'enabled'})
      } else {
        list.push({status: 'disabled'})
      }

    }
    setListStarts(list)
  }, [props.starts])

  if (listStarts.length === 0) return null

  return(
    <div className={'stars'}>
      {listStarts.map((start) => (
        <IconContext.Provider value={{ color: (start.status === 'enabled' ? "#ffb800" : ''), className: "star" }}>
          <div>
            <MdStar />
          </div>
        </IconContext.Provider>
      ))}
			{/* <IconContext.Provider value={{ color: "#ffb800", className: "star" }}>
			  <div>
			    <MdStar />
			  </div>
			</IconContext.Provider>
			<IconContext.Provider value={{ color: "#ffb800", className: "star" }}>
			  <div>
			    <MdStar />
			  </div>
			</IconContext.Provider>
			<IconContext.Provider value={{ color: "#ffb800", className: "star" }}>
			  <div>
			    <MdStar />
			  </div>
			</IconContext.Provider>
			<IconContext.Provider value={{className: "star" }}>
			  <div>
			    <MdStar />
			  </div>
			</IconContext.Provider> */}
		</div>
  )
}

export default StarsCommonLayout
